import { BaseEnum } from 'services/enums/baseEnum';

const listEnum: Array<FormItemChartType> = [];

export class FormItemChartType extends BaseEnum {
  static UNSET = new FormItemChartType(0, 'UNSET', 'Não definido', 'primary');
  static PIZZA = new FormItemChartType(1, 'PIZZA', 'Gráfico de Pizza', 'warning');
  static BAR = new FormItemChartType(2, 'BAR', 'Gráfico de Barras', 'danger');
  static THERMOMETER = new FormItemChartType(3, 'THERMOMETER', 'Termômetro', 'success');
  static BINARY_THERMOMETER = new FormItemChartType(4, 'BINARY_THERMOMETER', 'Termômetro Binário', 'dark');
  static COMMENT = new FormItemChartType(5, 'COMMENT', 'Comentário', 'secondary');
  static TEMPORAL_EVOLUTION = new FormItemChartType(
    6,
    'TEMPORAL_EVOLUTION',
    'Evolução temporal',
    'info'
  );

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public className: string
  ) {
    super(id, value, label, className);
    listEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listEnum.filter(item => item.value !== FormItemChartType.UNSET.value);
  }
}
